const config =  {
  APP_NAME: 'DEFAULT',
  API : {
    BASE_URL : 'http://18.144.68.79:3000',
    API_PREFIX: 'api',
    VERSION: 'v1'
  },
  PAGINATION : {
    ROW_COUNT: 10
  },
  PAGINATION_BID: {
    ROW_COUNT: 20
  },
  WORMHOLE : {
    EXPIRED_SOON_IN : 7776000000,
    TOP_BIDDERS_COUNT : 25,
    INITIAL_PRICE : '49.99'
  },
  EXPIRY_DUE : 90,
  USER:{
    PAGINATION : {
      ROW_COUNT: 20
    }
  },
  COUPON:{
    PAGINATION : {
      ROW_COUNT: 20
    }
  },
  USER_TYPES : {
    CUSTOMER : 1,
    ADMIN : 2,
    SUPER_ADMIN : 3
  },
  ADMIN_STATUS : {
    SUSPENDED : 0,
    ACTIVE : 1,
    PENDING : 2
  }
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/config/default.config.js